<template>
  <h3 class="h3">An welchem Standort?</h3>

  <div v-if="Object.values(allLocations).length == 0">
    <p>Keine Standorte gefunden</p>
  </div>
  <div v-else class="flex flex-wrap gap-2">
      <DateButton v-for="(item, index) in allLocations" :key="index" @click="select(item)"
        :id="item.ID" :main-text="item.Bezeichnung"
        :is-selected="isSelected(item.ID)"
      />
  </div>

  <div class="flex justify-between mt-5 items-center">
    <input type="button" class="button prev" :value="Navigation.ZURÜCK" @click="prev"/>
    <input type="button" class="button next" :disabled="nextDisabled" :value="Navigation.WEITER" @click="next"/>
  </div>
  <div class="text-center">
    <span class="!text-gray-200 !text-xs !font-sans">digital begeistert von <a href="https://www.codeandcomments.at" class="!underline !text-xs !text-gray-200 !font-sans">code & comments</a></span>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { DetailStep, Navigation } from '../../models/enums'
import { useStore } from 'vuex';
import { scrollToTop } from '@/models/helper';
import DateButton from '@/components/DateButton.vue';

const store = useStore();
const nextDisabled = computed(() => store.state.selectedLocation == null);
const select = (item) => store.commit("updateSelectedLocation", item);


const isSelected = computed(() => {
  return (id) => store.state.selectedLocation?.ID == id;
});
store.dispatch("LOAD_LOCATIONS");

const allLocations = computed(() => {
  return store.state.allLocations;
});

const prev = () => {
  store.commit("stepBack");
  scrollToTop();
}
const next = () => {
  store.commit("updateStep", DetailStep.TERMIN);
  scrollToTop();
}
</script>

<style scoped lang="scss">
h3 {
  @apply mb-3;
}
</style>
